import Button from 'components/features/pfm/Button/Button'
import { FC, useCallback, useMemo } from 'react'
import { OnboardingPagePreset } from 'components/features/creditCard/creditCardOnboarding/OnboardingPagePreset/OnboardingPagePreset'
import styles from 'components/features/creditCard/creditCardOnboarding/DeniedStepPage/DeniedStepPage.styl'
import { Link } from 'react-router-dom'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { pushActionCreator } from 'actions/navigationActions'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import moment from 'moment'
import { INDICATOR_EXCLAMATION_STEP } from 'components/features/pfm/StepIndicator/StepIndicator'

export const DeniedStepPage: FC = () => {
  const next_available_attempt_time = useStoreSelector((state) => state.data.creditCard.onboarding?.next_available_attempt_time ?? null)

  const cardChild = useMemo(() => {
    if (!next_available_attempt_time) {
      return (
        <LoadingOverlay />
      )
    }

    const timeLeft = moment(next_available_attempt_time).diff(moment())
    const daysLeft = moment.duration(timeLeft).asDays()
    const ceilDaysLeft = Math.ceil(daysLeft)

    return (
      <div className={ styles.note } data-qa-marker='form-note' data-qa-type='info'>
        We understand that this may not be the decision that you were expecting. You will receive a notification from us
        advising you of the reasons for the decline.
        <div className={ styles.suphead } data-qa-marker='sub-header' data-qa-type='request'>
          Please try again in
        </div>
        <div className={ styles.remainDays } data-qa-marker='remain-days'>
          { ceilDaysLeft }
        </div>
        <div className={ styles.subhead } data-qa-marker='sub-header' data-qa-type='ticker'>
          days.
        </div>
      </div>
    )
  }, [next_available_attempt_time])

  const dispatch = useStoreDispatch()
  const handleClose = useCallback(() => {
    dispatch(pushActionCreator('/credit-card'))
  }, [dispatch])

  return (
    <OnboardingPagePreset
      step={ INDICATOR_EXCLAMATION_STEP }
      title='Your application is not approved at this time'
      card={ cardChild }
      onClose={ handleClose }
      progressPercent={ 100 }
    >
      <div className={ styles.preset }>
        <Link to='/credit-card'>
          <Button
            text='Close'
            fullWidth
            qaMarker='cancel-button'
          />
        </Link>
      </div>
    </OnboardingPagePreset>
  )
}
